import { render, staticRenderFns } from "./ClientResponsibleList.vue?vue&type=template&id=6b5b4f90&"
import script from "./ClientResponsibleList.vue?vue&type=script&lang=js&"
export * from "./ClientResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./ClientResponsibleList.vue?vue&type=style&index=0&id=6b5b4f90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports